module.exports = __webpack_public_path__ + "img/gb13871-92_38x58x8.prt.e3630210.jpg";